export const getGroupBy = <T, KEY extends string | number>(data: T[], groupBy: (item: T) => KEY) => {
	return data.reduce((acc, val, idx) => {
		const key = groupBy(val);
		if (!acc[key]) acc[key] = [];
		acc[key].push(val);

		return acc;
	}, {} as Record<KEY, T[]>);
};
